module.exports = __webpack_public_path__ + "static/media/logo-gray.a3cec23b.svg";